import * as React from 'react'

import { ProductImageUrls } from '@thg-commerce/gravity-elements/Product/ProductImage/ProductImage'
import { ProductPriceProps } from '@thg-commerce/gravity-elements/ProductBlock/ProductPrice/ProductPrice'
import { ProductReviewProps } from '@thg-commerce/gravity-elements/Product/ProductReview/ProductReview'
import {
  ProductBlock,
  ProductBlockProps,
} from '@thg-commerce/enterprise-components'
import {
  StyledListItem,
  StyledProductGrid,
  ProductGridItem,
  DescriptionGridItem,
  TitleGridItem,
  ProductTitle,
  StyledText,
} from './style'

export interface TopProductProps {
  sku: string
  title: {
    value: string
  }
  url: string
  image: {
    urls: ProductImageUrls
    lazy?: boolean
  }
  reviews?: ProductReviewProps
  price?: ProductPriceProps
  button?: ProductBlockProps['button']
  condensed?: boolean
  description: string
}

export interface TopNProductsProps {
  isAmp: boolean
  products: TopProductProps[]
}

export const TopNProducts = ({ isAmp, products }: TopNProductsProps) => {
  const Products = products.map(
    (
      { sku, title, url, reviews, price, description, image, button },
      index,
    ) => {
      const clickHandler = () => window.location.assign(url)
      return (
        <StyledListItem key={index}>
          <StyledProductGrid>
            <TitleGridItem colSpan={12} rowStart={1}>
              <ProductTitle onClick={clickHandler}>
                <span>{index + 1}.</span>
                {title.value}
              </ProductTitle>
            </TitleGridItem>
            <ProductGridItem colSpan={[12, 4, 5, 4]} rowStart={2}>
              <ProductBlock
                sku={sku}
                url={url}
                image={{
                  ...image,
                  isAmp,
                  width: ['163px', '100%'],
                  height: ['163px', 'auto'],
                }}
                title={{ ...title, hideLabel: true }}
                price={price}
                review={reviews}
                button={button}
                directions={['row', 'column']}
              />
            </ProductGridItem>
            <DescriptionGridItem
              colSpan={[12, 8, 7, 8]}
              colStart={[0, 5, 6, 5]}
              rowStart={[3, 2, 2, 2]}
            >
              <StyledText
                content={description}
                __dangerouslyAllowedTags={['span', 'strong', 'em']}
              />
            </DescriptionGridItem>
          </StyledProductGrid>
        </StyledListItem>
      )
    },
  )
  return <ul>{Products}</ul>
}
